
<div class="containmer">
    <div class="row justify-content-center">
        <div class="col-xs-12 col-sm-5 col-xl-5 col-xxl-4">
            <mat-card class="p-2">
                <form [formGroup]="tiersForm" (ngSubmit)="addEditTierSubmit($event)">
                    <div class="form-inner content-details-blk">
                        <div class="row">
                            <div class="col-xs-6 col-sm-6 align-self-center">
                                <h4 class="form-item-label" >
                                    Retailer Tier Name
                                    <span class="required">*</span>
                                  </h4>
                            </div>
                            <div class="col-xs-6 col-sm-6">
                                <div class="form-item-input">
                                    <mat-form-field appearance="outline" class="w-100">
                                      <input
                                        matInput
                                        required
                                        formControlName="retailerTierName"
                                        placeholder="Retailer tier name"
                                      />
                                    </mat-form-field>
                                    <mat-error *ngIf="tiersForm.controls.retailerTierName.errors?.required && tiersForm.controls.retailerTierName.touched" class="text-danger ms-2 small-text">
                                        Retailer tier name is required!</mat-error
                                      >
                                  </div>
                            </div>
                            
                        </div>
                        <div class="row">
                            <div class="col-xs-6 col-sm-6 align-self-center">
                                <h4 class="form-item-label" >
                                    Sales Amount
                                    <span class="required">*</span>
                                  </h4>
                            </div>
                            <div class="col-xs-6 col-sm-6">
                                <div class="form-item-input">
                                    <mat-form-field appearance="outline" class="w-100">
                                      <input
                                        matInput
                                        required
                                        formControlName="salesAmount"
                                        placeholder=" Sales Amount"
                                      />
                                    </mat-form-field>
                                    <mat-error *ngIf="tiersForm.controls.salesAmount.errors?.required && tiersForm.controls.salesAmount.touched" class="text-danger ms-2 small-text">
                                        Sales Amount is required</mat-error
                                      >
                                  </div>
                            </div>
                            
                        </div>
                    </div>
                    <div class="form-footer text-center mt-3">
                        <button mat-raised-button  
                        [routerLink]="['../../']" routerLinkActive="router-link-active"
                        type="button" class="">Cancel</button>
                        <button mat-raised-button 
                        color="primary" type="submit" class=" ms-3">Submit</button>
                    </div>
                </form>
            </mat-card>
        </div>
    </div>
</div>